// extracted by mini-css-extract-plugin
export default {"timer":"style_timer__ivJec","time":"style_time__1kB8I","label":"style_label__PkFIN","svg":"style_svg__t5W8m","svg_circle":"style_svg_circle__tOuHU"};